/* eslint-disable import/prefer-default-export */
import { caseTransformingAxios } from "../../../shared/v2/caseTransformingAxios";

export const getPrevNextListingsAsApi = (uuid, params) =>
  caseTransformingAxios.get(`/api/v4/transactions/navigation_bar/navigation_slugs`, {
    params: { ...params, uuid },
  });
